import React from 'react';
import styles from '../Form.module.scss';
// @ts-ignore
import classNames from 'classnames';

type FormLabelPropsType = {
  children: React.ReactNode;
  className?: string;
  for?: string;
  id?: string;
};

const FormLabel = (props: FormLabelPropsType) => {
  return (
    <label htmlFor={props.for} className={classNames(styles.label, props.className)}>
      {props.children}
    </label>
  );
};

export default FormLabel;
